/* tslint:disable */
/* eslint-disable */
/**
 * EM2
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AssociatedObjectNotFoundExceptionResponse } from '../apiModels';
// @ts-ignore
import { TestDocumentDefinitionTypes } from '../apiModels';
/**
 * ItineraryBookletsDocumentTestApi - axios parameter creator
 * @export
 */
export const ItineraryBookletsDocumentTestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} forumId 
         * @param {TestDocumentDefinitionTypes} [reportType] 
         * @param {number} [forumGroupId] 
         * @param {number} [questionnaireId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumsForumIdBookletDocumentTestGet: async (forumId: number, reportType?: TestDocumentDefinitionTypes, forumGroupId?: number, questionnaireId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'forumId' is not null or undefined
            assertParamExists('forumsForumIdBookletDocumentTestGet', 'forumId', forumId)
            const localVarPath = `/forums/{forumId}/booklet-document-test`
                .replace(`{${"forumId"}}`, encodeURIComponent(String(forumId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (reportType !== undefined) {
                localVarQueryParameter['ReportType'] = reportType;
            }

            if (forumGroupId !== undefined) {
                localVarQueryParameter['ForumGroupId'] = forumGroupId;
            }

            if (questionnaireId !== undefined) {
                localVarQueryParameter['QuestionnaireId'] = questionnaireId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ItineraryBookletsDocumentTestApi - functional programming interface
 * @export
 */
export const ItineraryBookletsDocumentTestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ItineraryBookletsDocumentTestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} forumId 
         * @param {TestDocumentDefinitionTypes} [reportType] 
         * @param {number} [forumGroupId] 
         * @param {number} [questionnaireId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forumsForumIdBookletDocumentTestGet(forumId: number, reportType?: TestDocumentDefinitionTypes, forumGroupId?: number, questionnaireId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forumsForumIdBookletDocumentTestGet(forumId, reportType, forumGroupId, questionnaireId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ItineraryBookletsDocumentTestApi - factory interface
 * @export
 */
export const ItineraryBookletsDocumentTestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ItineraryBookletsDocumentTestApiFp(configuration)
    return {
        /**
         * 
         * @param {ItineraryBookletsDocumentTestApiForumsForumIdBookletDocumentTestGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumsForumIdBookletDocumentTestGet(requestParameters: ItineraryBookletsDocumentTestApiForumsForumIdBookletDocumentTestGetRequest, options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.forumsForumIdBookletDocumentTestGet(requestParameters.forumId, requestParameters.reportType, requestParameters.forumGroupId, requestParameters.questionnaireId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for forumsForumIdBookletDocumentTestGet operation in ItineraryBookletsDocumentTestApi.
 * @export
 * @interface ItineraryBookletsDocumentTestApiForumsForumIdBookletDocumentTestGetRequest
 */
export interface ItineraryBookletsDocumentTestApiForumsForumIdBookletDocumentTestGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ItineraryBookletsDocumentTestApiForumsForumIdBookletDocumentTestGet
     */
    readonly forumId: number

    /**
     * 
     * @type {TestDocumentDefinitionTypes}
     * @memberof ItineraryBookletsDocumentTestApiForumsForumIdBookletDocumentTestGet
     */
    readonly reportType?: TestDocumentDefinitionTypes

    /**
     * 
     * @type {number}
     * @memberof ItineraryBookletsDocumentTestApiForumsForumIdBookletDocumentTestGet
     */
    readonly forumGroupId?: number

    /**
     * 
     * @type {number}
     * @memberof ItineraryBookletsDocumentTestApiForumsForumIdBookletDocumentTestGet
     */
    readonly questionnaireId?: number
}

/**
 * ItineraryBookletsDocumentTestApi - object-oriented interface
 * @export
 * @class ItineraryBookletsDocumentTestApi
 * @extends {BaseAPI}
 */
export class ItineraryBookletsDocumentTestApi extends BaseAPI {
    /**
     * 
     * @param {ItineraryBookletsDocumentTestApiForumsForumIdBookletDocumentTestGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItineraryBookletsDocumentTestApi
     */
    public forumsForumIdBookletDocumentTestGet(requestParameters: ItineraryBookletsDocumentTestApiForumsForumIdBookletDocumentTestGetRequest, options?: AxiosRequestConfig) {
        return ItineraryBookletsDocumentTestApiFp(this.configuration).forumsForumIdBookletDocumentTestGet(requestParameters.forumId, requestParameters.reportType, requestParameters.forumGroupId, requestParameters.questionnaireId, options).then((request) => request(this.axios, this.basePath));
    }
}

